/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IResourceInfo, IViewResource } from "../../view/IView";
import { useStateWithEvent } from "./useStateWithEvent";

export function useResourceInfo(view: IViewResource): IResourceInfo {
	const resourceInfo = useStateWithEvent(view.onResourceInfoChanged, () => view.getResourceInfo());

	return resourceInfo;
}
